export const setAppLoading = (payload: boolean) => ({
  type: "SET_APP_LOADING",
  payload,
});
export const savePrevPathname = (payload: string) => ({
  type: "SAVE_PREV_PATHNAME",
  payload,
});
